import { h as __h } from "preact";
/** @import { JSX } from "preact"; */

import html from "~/util/html.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Select.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Select.module.css", import.meta.url);
const css = adopt(sheet);
import Icon from "./Icon.js";
import button from "~/style/button.js";

/** @param {JSX.SelectHTMLAttributes<HTMLSelectElement>} props */
export default function Select(props) {
  const {
    children,
    ...rest
  } = props;
  return __h("select", {
    ...rest,
    "class": css.select + " " + button.button
  }, __h("button", {
    type: "button"
  }, __h("selectedcontent", {}), __h("span", {
    "class": css.icon
  }, __h(Icon, {
    name: "down",
    size: 8,
    stroke: 1
  }))), children);
}